const { showLoader, hideLoader } = require('../loader/loader');
const { openModal } = require('../modal/modal');
const { showElement, hideElement } = require('/src/common/js');

const formQuick = document.forms?.formQuick;
const formFeedback = document.forms?.formFeedback;
const formFeedbackModal = document.forms?.formFeedbackModal;

const modalBoxForm = document?.querySelector('[data-modalbox="form"]');
const modalBoxMsg = document?.querySelector('[data-modalbox="msg"]');

formQuick?.addEventListener('submit', onFormSubmit);
formFeedback?.addEventListener('submit', onFormSubmit);
formFeedbackModal?.addEventListener('submit', onFormSubmit);
document.addEventListener('input', onPhoneInput);

function onFormSubmit(e) {
  e.preventDefault();

  const form = e.target;
  // const formName = form?.getAttribute('name');
  const nameValue = form?.name?.value?.trim();
  const phoneValue = form?.phone?.value;
  const emailValue = form?.email?.value?.trim();
  const messageValue = form?.msg?.value?.trim();

  // Перевірка правильності введення номера телефону
  const phoneRegex = /^\+380\d{9}$/; // Маємо +380935664772
  if (!phoneRegex.test(phoneValue)) {
    alert('Невірний формат номера телефону. Має бути у форматі +380991234567');
    return;
  }

  const data = { name: nameValue, phone: phoneValue };
  if (emailValue) data.email = emailValue;
  if (messageValue) data.message = messageValue;

  const formData = new FormData();

  for (const key in data) {
    formData.append(key, data[key]);
  }

  sendMessage(form, formData);
}

async function sendMessage(formRef, formData) {
  let sendURL = '/sendMessage.php';

  showLoader();
  setTimeout(() => {
    hideLoader();
  }, 1500);

  try {
    let response = await fetch(sendURL, {
      method: 'POST',
      body: formData,
    });
    if (response.ok) {
      openModal();
      hideElement(modalBoxForm);
      showElement(modalBoxMsg);
    } else {
      openModal();
      hideElement(modalBoxForm);
      showElement(modalBoxMsg);
    }
  } catch (exceptionVar) {
    formRef?.reset();
  } finally {
    formRef?.reset();
  }
}

function onPhoneInput(e) {
  const isAvalibleInput = e.target.getAttribute('type') === 'tel';
  if (!isAvalibleInput) return;

  let value = e.target.value.replace(/[^\d+]/g, ''); // дозволяємо вводити тільки цифри та +

  // Якщо введено щось інше, автоматично додаємо "+38" на початок
  if (value && !value.startsWith('+380')) {
    value = '+380' + value.slice(4); // додаємо "+38" якщо це ще не є
  }

  // Маскуємо номер телефону
  // Обрізаємо до максимальної довжини: +380935664772
  if (value.length > 13) value = value.slice(0, 13);

  e.target.value = value;
}
